<ngx-spinner
  bdColor="rgba(245, 245, 245, 0.7)"
  size="medium"
  type="ball-spin-clockwise"
  [fullScreen]="true"
>
  <div class="d-flex align-items-center flex-column">
    <div class="loader-ring">
      <img src="assets/images/rec-hr-logo.svg" alt="Loading..." class="loader-logo h-auto" />
    </div>
  </div>
</ngx-spinner>
